import React, { useState } from 'react';
import cx from '../../../../styles';
import {gtmSend} from '../../../../helpers';

export const SingleChoicePrePoll = ({pollChoices, voteHandler, match}) => {

    const [isVoted, setIsVoted] = useState(false);

    const onClickHandler = (pollId, choiceId) => {
        if(!isVoted){
            setIsVoted(true);
            document.getElementById(choiceId).classList.add('active');
            voteHandler(pollId, choiceId);
            gtmSend('dynamic', 'Poll Card', 'click-poll-click', match.path);
        }
    }

    return (
        <div className={cx('pre-poll-state')}>
            {
                pollChoices.map((choice) => {
                    return (
                        <div className={cx("poll-bar-row")} key={choice.id} id={choice.id}>
                            <span className={cx("radio-btn")} onClick={()=> onClickHandler(choice.poll_id, choice.id)}></span>
                            <div title={choice.message} className={cx("poll-bar")} onClick={()=> onClickHandler(choice.poll_id, choice.id)}>
                                {/*<label className={cx("redio-check")}></label>*/}
                                <span>{choice.message}</span>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}

export const SingleChoicePostPoll = ({votes, voteHandler}) => {
    return (
        <div className={cx('post-poll-state')}>
            {
                votes.map((vote) => {
                    //let gradientStyle = '#fff';  //`-webkit-linear-gradient(left, #ffe2c3 ${vote.percentage}%, #fff 0%)`;

                    //if(vote.user_choice == 1) {
                        //gradientStyle = '#fff'; //`-webkit-linear-gradient(left, #fc7898, #fc8a10 ${vote.percentage}%, #fff 0%)`;
                    //}

                    return (
                        <div className={cx("poll-bar-row", vote.user_choice == 1 ? "chosen" : "")} key={vote.choice_id}>
                            <div>{vote.percentage}%</div>
                            
                            <div title={vote.message} className={cx("poll-bar")} onClick={()=>voteHandler(vote.poll_id, vote.choice_id)}>
                                
                                <div style={{width: vote.percentage + "%"}}></div>

                                {/*<input className={cx("hide", (vote.user_choice == 1 ? "visible" : ""))} type = "radio" defaultChecked />*/}

                                <span>{vote.message}</span>
                            </div>
                            
                        </div>
                    );
                })
            }
        </div>
    );
}
